/**
 * Centralized state management for supported locales
 * This eliminates the duplicate state problem between locales.js and localeNavigation.js
 */
import { LOCALES } from '../constants/locales.js';
// Single source of truth for supported locales
let supportedLocales = LOCALES.map(l => l.code);
/**
 * Get the current supported locales array
 * @returns {string[]} Array of supported locale codes
 */
export function getSupportedLocales() {
    return [...supportedLocales]; // Return copy to prevent external modification
}
/**
 * Update the supported locales (called from initializeLocales)
 * @param {string[]} newSupportedLocales - New array of supported locale codes
 */
export function setSupportedLocales(newSupportedLocales) {
    if (!Array.isArray(newSupportedLocales)) {
        throw new Error('setSupportedLocales: Expected array of locale codes');
    }
    supportedLocales = [...newSupportedLocales];
}
/**
 * Check if a locale is currently supported
 * @param {string} localeCode - The locale code to check
 * @returns {boolean} True if the locale is supported
 */
export function isLocaleSupported(localeCode) {
    return supportedLocales.includes(localeCode);
}
